// extracted by mini-css-extract-plugin
export default {"hint":"hint_hint__CKOiY","danger":"hint_danger__K8pXM","warning":"hint_warning__h272h"};